<template>
  <core-layout flat go-back title="Insurance Log">
    <v-container fluid>
      <v-row v-if="items.length > 0" dense>
        <v-col
          v-for="(item, i) in items"
          :key="`${i}-insurance-list`"
          cols="12"
        >
          <v-card flat outlined @click="showDetail(item)">
            <v-card-text class="pb-0">
              <v-row dense>
                <v-col cols="2"><v-icon>local_hospital </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.insuranceName }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Insurance
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"><v-icon>add_business </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.branchName }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Branch
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"><v-icon>perm_identity </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.doctor }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Doctor
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"><v-icon>schedule </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.date | dateTime }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Date
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"><v-icon>attach_money </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.value }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Value
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"
                  ><v-icon v-if="item.status == -1">error</v-icon>
                  <v-icon v-else>done</v-icon>
                </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.status == -1 ? 'Canceled' : 'Approved' }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Status
                  </h5>
                </v-col>
                <v-col cols="12">
                  <v-divider inset></v-divider>
                </v-col>

                <v-col cols="2"><v-icon outlined>note </v-icon> </v-col>
                <v-col cols="10">
                  <h3>
                    {{ item.notes }}
                  </h3>
                  <h5 class="font-weight-medium">
                    Note
                  </h5>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-btn
            block
            text
            rounded
            color="primary"
            @click="searchItems()"
            v-if="param.page < totalPages"
            >Load More</v-btn
          >
        </v-col>
      </v-row>
      <v-card v-else :loading="loading">
        <v-card-text @click="searchItems()">
          <v-row dense>
            <v-col cols="10">
              <div>
                No record found.<br />
                Please wait a minute and try to refesh.
              </div>
            </v-col>
            <v-col cols="2">
              <v-card-actions>
                <v-btn icon :disabled="loading">
                  <v-icon color="primary">refresh</v-icon>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </core-layout>
</template>
<script>
export default {
  data: () => ({
    items: [
      {
        branchName: 'branch',
        insuranceName: 'insurance name',
        date: '2019-11-01 05:22:07.64',
        doctor: 'doctor name',
        value: 100,
        status: 1,
        notes: 'note'
      },
      {
        branchName: 'branch',
        insuranceName: 'insurance name',
        date: '2019-11-01 05:22:07.64',
        doctor: 'doctor name',
        value: 100,
        status: -1,
        notes: 'note'
      }
    ],
    loading: false,
    errorMessage: '',
    param: { page: 0 },
    totalPages: 1
  }),
  computed: {},
  created () {
    this.searchItems()
  },
  methods: {
    searchItems () {
      const params = {
        page: this.param.page++
      }
      this.loading = true
      this.$http
        .get('/insurances/transactions', { params })
        .then(r => {
          const items = r.data.data.items || []
          if (!items || !items.length) {
            this.items = []
            this.param.page = 1
            return
          }
          this.totalPages = r.data.data.totalPages

          this.items = items
        })
        .catch(e => {
          this.param.page = 0
          this.totalPage = 1

          this.$dialog.alert(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showDetail (v) {
      // TODO get by id
    }
  }
}
</script>
